import SmartApi from './src/SmartAPI';
import AxiosTransport from './src/AxiosTransport';
import axios from 'axios';

export default new SmartApi(new AxiosTransport(axios));
